import { operationsTransformer } from './operation';
import { Map } from 'immutable';

export const transformOneComment = (data) => {
	const result = {
		id: data.id,
		title: data.title,
		viewContent: data.body && data.body.view ? data.body.view.value : null,
		editorContent:
			data.body && data.body.atlas_doc_format ? data.body.atlas_doc_format.value : null,
		operations: data.operations ? operationsTransformer(data.operations) : Map({}),
		history: data.history ? data.history : {},
		author: data.history ? data.history.createdBy : {},
		version: data.version,
	};
	return result;
};

export const commentsTransformer = (comments = []) => {
	return {
		results: comments.map(transformOneComment),
	};
};
